module.exports = __webpack_public_path__ + "208bca8a7a9b2e90c2957f8e2b151eb9.png";